import React from 'react';
import { useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { userPreferencesState } from '../TicketListSlice';

export default function SaveViewPopUp(props) {
  const { openSaveViewPopUp } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [viewName, setViewName] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const userPreferences = useSelector(userPreferencesState);

  function closeSaveViewPopUp() {
    props.closeSaveViewPopUp(false);
  }

  function isViewNameAlreadyRegistered(newViewName) {
    const preferenceRegistered = userPreferences.find(
      (userPreference) => userPreference.viewName === newViewName,
    );
    return preferenceRegistered !== undefined;
  }

  function hasMoreThanFiftyViews() {
    return userPreferences.length > 50;
  }

  function saveView() {
    if (isViewNameAlreadyRegistered(viewName)) {
      setErrorMessage(
        'View name is already registered, please choose another one',
      );
    } else if (hasMoreThanFiftyViews()) {
      setErrorMessage('You have too many views, please delete one');
    } else {
      props.saveView(viewName);
      setViewName('');
    }
  }

  function handleChange(e) {
    setViewName(e.target.value);
    if (viewName.length > 25) {
      setErrorMessage('View name is too long');
    } else {
      setErrorMessage('');
    }
  }

  return (
    <Dialog
      open={openSaveViewPopUp}
      onClose={closeSaveViewPopUp}
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <WarningIcon className={classes.warningIcon} fontSize="large" />
        </Grid>
        <Grid item xs={11}>
          <DialogTitle className={classes.dialogTitle}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography className={classes.title}>
                  {t('You are creating a new view')}
                </Typography>
              </Box>
              <Box>
                <IconButton onClick={closeSaveViewPopUp}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText className={classes.dialogText}>
              {t('creating new view message')}
            </DialogContentText>
            <TextField
              className={classes.input}
              variant="outlined"
              size="small"
              fullWidth
              placeholder={t('Inform the name')}
              InputProps={{ classes: { input: classes.inputStyle } }}
              value={viewName}
              onChange={handleChange}
              error={errorMessage !== ''}
              helperText={errorMessage}
            />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              className={classes.cancelButton}
              onClick={closeSaveViewPopUp}
              color="secondary"
              variant="outlined"
            >
              {t('Cancel')}
            </Button>
            <Button
              className={classes.validateButton}
              onClick={saveView}
              color="secondary"
              variant="contained"
              autoFocus
              disabled={viewName === '' || errorMessage !== ''}
            >
              {t('Validate')}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
}
